import { createStore, combineReducers, applyMiddleware } from 'redux';
import reducers from '../reducers';
import thunk from 'redux-thunk';
import client from '../api/client';
import SessionManager from 'eebac/utils/session';


export const USER_SIGNOUT = `APP/USER_SIGNOUT`;

export const userSignOut = () => ({
  type: USER_SIGNOUT,
});

const appReducer = combineReducers({
  ...reducers
})

const rootReducer = (state, action) => {
  if (action.type === USER_SIGNOUT) {
    SessionManager.setAuthToken(null);
    SessionManager.setAuthRToken(null);
    SessionManager.setAuthUser(null);
    state = undefined;
  }

  return appReducer(state, action)
}

export default function configureStore() {
  return createStore(
    rootReducer,
    applyMiddleware(thunk.withExtraArgument(client))
  );
}
